<template>
  <div class="project">
    <div class="steps">
      <a-steps :current="currentSteps" labelPlacement="vertical" v-if="isStep">
        <a-step title="基础信息"> </a-step>
        <a-step title="开通服务" />
      </a-steps>
      <keep-alive>
        <OrganizationForm v-if="currentSteps == 0" :orgId="oId" ref="organizationForm" :detail="detail" @getDetail="getDetail" @changeDetail="changeDetail" />
        <Step2 ref="Step2" v-if="currentSteps == 1" :orgId="oId" :detail="detail" />
      </keep-alive>
    </div>

    <div class="modal-footer">
      <a-button v-if="currentSteps == 0 && isStep" :disabled="loading" @click="nextStep(true)" style="margin-right: 16px">保存并退出</a-button>
      <a-button :disabled="loading" type="primary" @click="nextStep(false)" style="margin-right: 8px">{{ currentSteps == 1 ? '上一步' : !isStep ? '保存' : '保存并配置服务' }}</a-button>
      <a-button :loading="loading" v-if="currentSteps == 1" type="primary" @click="submit">完成</a-button>
    </div>
  </div>
</template>
<script>
import OrganizationForm from '@/pages/projectImpl/orgManage/components/OrganizationForm.vue'
import Step2 from '@/pages/projectImpl/orgManage/components/orgStep2.vue'
export default {
  name: 'AddProject',
  components: { OrganizationForm, Step2 },
  computed: {
    isStep() {
      return (!this.detail.superiorId && this.$route.query.id) || (!this.$route.query.id && !this.detail.superiorId)
    },
  },
  data() {
    return {
      loading: false,
      currentSteps: 0,
      oId: this.$route.query.id,
      detail: {
        superiorId: false,
      },
    }
  },
  provide() {
    return {
      oId: this.$route.query.id,
    }
  },
  created() {
    // const breadcrumb = this.$store.state.account.breadcrumb
    // breadcrumb.pop()
    // if (this.$route.query.id) {
    //   breadcrumb.push({
    //     name: '编辑机构',
    //     path: this.$route.fullPath,
    //   })
    // } else {
    //   breadcrumb.push({
    //     name: '添加机构',
    //     path: this.$route.fullPath,
    //   })
    // }
    // $Bus.$emit('pageHeaderTitle',breadcrumb.at(-1).name)
    // this.$store.commit('account/set_breadcrumb', breadcrumb)
  },
  methods: {
    addProjectOk() {
      return new Promise((resolve, reject) => {
        this.$refs.organizationForm.validate((valid) => {
          if (valid) {
            const Ajax = this.oId ? this.$http.Mechanism.mechanismOrganizationUpdate : this.$http.Mechanism.mechanismOrganizationAdd
            this.loading = true
            const params = this.$refs.organizationForm.form
            if (this.oId) {
              params.id = this.oId
            }
            Ajax(params)
              .then((res) => {
                this.loading = false
                const { data } = res
                // InterfaceHttp 已经显示了成功消息
                if (!this.oId && data) {
                  this.oId = data
                }
                this.changeDetail(params)
                resolve(data)
              })
              .catch((e) => {
                this.loading = false
                // 网络错误等异常，InterfaceHttp 可能已经显示了错误消息
                reject()
              })
          } else {
            reject()
            return false
          }
        })
      })
    },
    addProjectCancel() {
      if (this.currentSteps == 1) {
        return this.$confirm({
          title: `确认放弃该步骤填写？`,
          content: '',
          centered: true,
          onOk: () => {
            this.$refs.organizationForm && this.$refs.organizationForm.resetForm()
            this.$router.go(-1)
            this.currentSteps == 0
          },
        })
      }
      this.$refs.organizationForm && this.$refs.organizationForm.resetForm()
      this.$router.go(-1)
      this.currentSteps == 0
    },
    changeDetail(detail = {}) {
      this.detail = { ...this.detail, ...detail }
    },
    getDetail(id) {
      let params = {
        organizationId: id,
      }
      this.$http.UserManage.getOrganizationInfo(params).then((res) => {
        const { data } = res
        this.detail = data
          this.$nextTick(() => {
            for (const formKey in this.$refs.organizationForm.form) {
              this.$refs.organizationForm.form[formKey] = data[formKey]
            }
            this.$refs.organizationForm.id = params.organizationId || undefined
            this.$refs.organizationForm.form.superiorId = data.superiorId || undefined
            this.$refs.organizationForm.form.adminIds = data.admins?.map((m) => m.adminId)
            this.$refs.organizationForm.form.roleIds = data.roles?.map((m) => m.roleId)
            // 如果 hasSubOrganization==true 则有下级机构
            if (data.hasSubOrganization) {
              this.$refs.organizationForm.form.property = 0
            } else {
              this.$refs.organizationForm.form.property = data.property
            }
            this.$refs.organizationForm.form.hasSubOrganization = data.hasSubOrganization
            this.$refs.organizationForm.setting()
          })
      })
    },
    async changeStatusCloud(e) {
      const fm = new FormData()
      fm.append('organizationId', this.oId)
      fm.append('openCloud', e)
      await this.$http.Mechanism.updateOrganizationSettings(fm)
    },
    async nextStep(back) {
      if (this.currentSteps == 0) {
        await this.addProjectOk()
        if (!this.isStep || back) {
          const businessType = this.$refs.organizationForm.form?.businessType
          if (this.oId && !this.$route.query.id && businessType == 1) {
            this.changeStatusCloud(true)
          }
          return this.$router.back()
        }
        this.currentSteps = 1
      } else {
        this.currentSteps = 0
      }
    },
    async saveSetting() {
      const step2 = this.$refs['Step2']
      const Params = {
        ...step2.orgSetting.data,
        organizationId: this.oId,
      }
      if (!Params.productServiceType) {
        this.$message.error('请至少需要开通一个产品服务')
        return Promise.reject()
      }
      return this.$http.Mechanism.updateOrganizationSettings(Params)
    },
    async submit() {
      // if (!this.$refs['Step2'].orgSetting.data.openCloud) {
      //   return this.$router.back()
      // }
      if (this.$refs['Step2'].data.length == 0 && this.detail.businessType === 1) {
        this.$message.destroy()
        return this.$message.error('请添加超级管理员')
      }
      const params = this.$refs['Step2'].getForm()
      this.loading = true
      await this.saveSetting().finally(() => (this.loading = false))
      const { data } = await this.$http.Mechanism.EditOrganizationModule({
        organizationId: this.oId,
        authorityInfos: params,
      }).finally(() => (this.loading = false))
        this.$message.success('保存成功')
        this.$router.back()
        this.currentSteps == 0
    },
  },
}
</script>
<style lang="less" scoped>
.project {
  background: #fff;
  padding: 20px 0;
  .steps {
    width: 50%;
    margin-left: 25%;
    padding-bottom: 60px;
  }
  .modal-body {
    width: 50%;
    margin-left: 25%;
  }
  .modal-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
